// pages/Contact.jsx


import ContactForm from "../components/contact/ContactForm";
import ContactHero from "../components/contact/ContactHero";

const Contact = () => {
  return (
    <>
      <ContactHero />
      <ContactForm />

      
    </>
  );
};

export default Contact;